<template>
    <div style="margin: 40px;">
      <el-tabs v-model="kftab">
        <el-tab-pane label="客服管理" name="kfgl">
          <el-table
            :data="kflist"
            highlight-current-row
            ref="multipleTable">
            <el-table-column
              prop="kf_account"
              label="客服账号">
            </el-table-column>
            <el-table-column
              prop="kf_id"
              label="客服账号">
            </el-table-column>
            <el-table-column
              label="头像">
              <template slot-scope="scope">
                <div v-if="scope.row.kf_headimgurl !== ''">
                  <img :src="scope.row.kf_headimgurl" class="avatarimg">
                </div>
                <div v-else>
                  {{scope.row.kf_headimgurl}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="kf_nick"
              label="客服昵称">
            </el-table-column>
            <el-table-column
              prop="kf_wx"
              label="客服微信">
            </el-table-column>
            <el-table-column
              label="操作"
              width="80px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="邀请客服" placement="top-start">
                  <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="yqkf(scope.$index, kflist)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="注销该客服" placement="top-start">
                  <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="delkf(scope.$index, kflist)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog title="添加客服" :visible.sync="kfvis">
            <el-row>
              <el-form style="margin-top: 20px; margin-left: 20px;" ref="form"  label-width="120px" label-position="left">
                <el-form-item label="客服账号：">
                  <el-input  v-model="kfaccount" placeholder="请输入客服账号，只允许英文+数字"></el-input>
                </el-form-item>
                <el-form-item label="客服昵称:">
                  <el-input v-model="kfnickname" placeholder="请输入客服昵称，只允许英文+数字"></el-input>
                </el-form-item>
                <el-button style="margin-top: 20px;" @click="ljtj">立即添加</el-button>
              </el-form>
            </el-row>
          </el-dialog>
          <el-button style="margin-left:20px; margin-top: 20px;" @click="zdkf">添加新客服</el-button>
        </el-tab-pane>
        <el-tab-pane label="客服消息" name="kfmsg">
          <el-row>
            <el-col :span="12">
              <el-table
                stripe
                :data="userlist">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  min-width="30px"
                  prop="openid"
                  label="OpenId"
                >
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="120px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="查看用户" placement="top-start">
                      <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="getuserinfo(scope.$index, userlist)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="12">
              <el-form label-width="100px" label-position="left" style="margin-left:30px;">
                <el-form-item label="昵称:">
                  <el-input
                    type="text"
                    autosize=""
                    placeholder="昵称"
                    v-model="nickname">
                  </el-input>
                </el-form-item>
                <el-form-item label="国家:">
                  <el-input
                    type="text"
                    autosize=""
                    placeholder="请输入标题"
                    v-model="country">
                  </el-input>
                </el-form-item>
                <el-form-item label="省：">
                  <el-input
                    type="text"
                    autosize=""
                    placeholder="请输入标题"
                    v-model="province">
                  </el-input>
                </el-form-item>
                <el-form-item label="市：">
                  <el-input
                    type="text"
                    autosize=""
                    placeholder="请输入标题"
                    v-model="city">
                  </el-input>
                </el-form-item>
                <el-form-item label="头像：">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="imgurl"></el-image>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'WxKF',
    data () {
      return {
        kftab: 'kfgl',
        userlist: [],
        kflist: [],
        imgurl: '',
        city: '',
        nickname: '',
        kfaccount: '',
        kfnickname: '',
        kfvis: false,
        country: '',
        province: ''
      }
    },
    mounted () {
      that = this
      that.getkflist()
      that.getuserlist()
    },
    methods: {
      yqkf (index,data) {
        this.$prompt('邀请微信号加入客服', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(({ value }) => {
          var adata = {
            'kf_account': data[index].kf_account,
            'invite_wx': value
          }
          window.console.log(adata)
          that.$http({
            url: 'https://wx.sqnetsoft.cn/wx/yqkf',
            method: 'post',
            data: adata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.result === 'success') {
                that.$message.success('添加客服完毕')
                // 把相关数据缓存到本地
              } else {
                that.$message.info(res.data.data)
              }
            })
            .catch(function (error) {
              window.console.log(error)
            })
        })
      },
      zdkf () {
        that.kfvis = true
      },
      ljtj () {
        var adata = {
          'kf_account': that.kfaccount + '@gh_2fb894b20337',
          'nickname': that.kfnickname
        }
        window.console.log(adata)
        that.$http({
          url: 'https://wx.sqnetsoft.cn/wx/addkf',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message.success('添加客服完毕')
              that.getkflist()
              // 把相关数据缓存到本地
            } else {
            }
          })
          .catch(function (error) {
            window.console.log(error)
          })
      },
      delkf (index, data) {
        window.console.log(data[index])
        var adata = {
          'kf_account': data[index].kf_account
        }
        window.console.log(adata)
        that.$http({
          url: 'https://wx.sqnetsoft.cn/wx/delkf',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message.success('添加客服完毕')
              that.getkflist()
              // 把相关数据缓存到本地
            } else {
            }
          })
          .catch(function (error) {
            window.console.log(error)
          })
      },
      getkflist () {
        that.$http({
          url: 'https://wx.sqnetsoft.cn/wx/getkf',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              var tmpdata = JSON.parse(res.data.data)
              window.console.log(tmpdata)
              that.kflist = tmpdata.kf_list
              // 把相关数据缓存到本地
            } else {
            }
          })
          .catch(function (error) {
            window.console.log(error)
          })
      },
      getuserinfo (index, data) {
        that.$http({
          url: 'https://wx.sqnetsoft.cn/wx/getuserbyopenid',
          method: 'post',
          data: {
            openid: data[index].openid
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              var tmpdata = JSON.parse(res.data.data)
              window.console.log(tmpdata)
              that.nickname = tmpdata.nickname
              that.imgurl = tmpdata.headimgurl
              that.city = tmpdata.city
              that.country = tmpdata.country
              that.province = tmpdata.province
              window.console.log(that.imgurl)
              // 把相关数据缓存到本地
            } else {
            }
          })
          .catch(function (error) {
            window.console.log(error)
          })
      },
      getuserlist () {
        that.$http({
          url: 'https://wx.sqnetsoft.cn/wx/getuseropenids',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              var tmpdata = JSON.parse(res.data.data)
              window.console.log(tmpdata)
              that.userlist = []
              for (var i = 0; i < tmpdata.data.openid.length; i++) {
                var data = {
                  openid: tmpdata.data.openid[i]
                }
                that.userlist.push(data)
              }
              // 把相关数据缓存到本地
            } else {
            }
          })
          .catch(function (error) {
            window.console.log(error)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/wx/WxKF.vue